module.exports = __webpack_public_path__ + "./font/Material-Design-Iconic-Font.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-design-iconic-font/dist/fonts/Material-Design-Iconic-Font.woff2?v=2.2.0
 ** module id = 216
 ** module chunks = 0
 **/